import { Injectable } from '@angular/core';
import { getBannerByType } from './bannerService';

@Injectable({
  providedIn: 'root'
})
export class BannerPreloadService {

  private timeout(ms: number): Promise<void> {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
  }

  /** Pre-fetches the HOME banner URL AND preloads the image bytes so
   *  that HeroComponent renders with the image already in browser cache. 
   * 
  */
  async preloadHomeBanner(): Promise<void> {
    try {
      // Allow up to 2 s for the API call; bail gracefully if slower
      const banner = await Promise.race([getBannerByType('HOME'), this.timeout(2000)]) as any;
      if (banner?.imageUrl) {
        // Allow up to 1.5 s for the image bytes to arrive in browser cache
        await Promise.race([
          new Promise<void>((resolve) => {
            const img = new Image();
            img.onload = img.onerror = () => resolve();
            img.src = banner.imageUrl;
          }),
          this.timeout(1500),
        ]);
      }
    } catch (err) {
      /* non-fatal — loader dismisses anyway */
    }
  }

  /**
    * Dismisses the initial application loader by applying a fade-out animation
    *and removing the loader element from the DOM after the animation completes.
  */
  dismissLoader(): void {
    const loader = document.getElementById('app-loader');
    if (!loader) return;
    loader.classList.add('fade-out');
    setTimeout(() => loader.remove(), 400);
  }
}
